import { toDrafts } from '../../server/to-drafts.js';
import { toOrderLineItem } from '../line-item/order-line-item.js';
import '@grandvisionhq/utils';
import '../utils/get-payment-status-label.js';
import { isSupportedLineItem } from '../utils/order-line-item-product-type-guards.js';
import '@grandvisionhq/graphql';
import { getShipmentStatusLabel } from '../utils/get-shipment-status-label.js';
import { getOrderStatusLabel } from '../utils/get-order-status-label.js';

const toOverviewOrder = (order, intl, options = {})=>{
    const lineItems = order.lineItems.filter(isSupportedLineItem);
    var _paymentStatus;
    return {
        drafts: toDrafts(lineItems),
        lineItems: lineItems.map((lineItem)=>toOrderLineItem(intl, options, lineItem)
        ),
        orderNumber: order.orderNumber,
        orderDate: new Date(order.orderDate),
        paymentStatus: (_paymentStatus = order.paymentStatus) !== null && _paymentStatus !== void 0 ? _paymentStatus : '',
        orderStatus: getOrderStatusLabel(order.state, intl),
        shipmentStatus: getShipmentStatusLabel(order.shipmentStatus, intl)
    };
};

export { toOverviewOrder };
//# sourceMappingURL=order-overview.js.map
